import RainbowTextField from '@components/RainbowTextField/RainbowTextField'
import { Stack, Typography } from '@mui/material'
import React, { useCallback, useState } from 'react'
import * as bip39 from '@scure/bip39'
import { Ed25519KeyIdentity } from '@dfinity/identity'
import { importKeypairWallet } from '@plug-core/handlers/walletActions/wallet'
import Button from '@components/Button'
import { useNavigate } from 'react-router-dom'
import { logger } from '@plug-core/logger'
import useFindTokens from '@plug-core/hooks/useFindTokens'
import { useTranslation } from 'react-i18next'

const WalletImportStoic = () => {
  const [seedPhrase, setSeedPhrase] = useState<string>()
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()
  const { findTokens } = useFindTokens()
  const { t } = useTranslation()

  const performImport = useCallback(() => {
    if (!seedPhrase) return

    setIsLoading(true)

    const seed = bip39.mnemonicToSeedSync(seedPhrase.trim())
    let seedArray = Array.from(seed)
    seedArray = seedArray.splice(0, 32)
    const identity = Ed25519KeyIdentity.generate(new Uint8Array(seedArray))

    importKeypairWallet(JSON.stringify(identity.toJSON()), 'ed25519')
      .then(async (wallet) => {
        await findTokens(wallet.principal)
        navigate(-2)
      })
      .catch(logger.debug)
  }, [seedPhrase])

  return (
    <Stack spacing={2} px={2}>
      <RainbowTextField
        value={seedPhrase}
        onChange={(e) => setSeedPhrase(e.target.value)}
        placeholder={t('importWalletStoic.seedPhrasePlaceholder')}
        rows={4}
        multiline
      />
      <Typography>{t('importWalletStoic.subbaccountWarning')}</Typography>
      <Typography>{t('importWalletStoic.seedPhraseInfo')}</Typography>
      <Button
        onClick={performImport}
        fullWidth
        variant="rainbow"
        loading={isLoading}
        disabled={isLoading}
      >
        {t('importWalletStoic.import')}
      </Button>
    </Stack>
  )
}

export default WalletImportStoic
